<template>
  <div class="container">

     <section v-if="singleItem.length > 0"> 
          <Single :item="singleItem" />
     </section> 
    <section v-if="filteredItems.length > 0"> 
          <ServiceCategory :items="filteredItems" />
     </section> 
 <section v-if="filteredRegion.length > 0"> 
   <ServiceCategory :items="filteredRegion" />
     </section> 

  </div>
</template>

<script>
import { dataPromise } from '@/stores/store.js';
import Single from '@/components/Single';
import ServiceCategory from '@/components/ServiceCategory';
  export default {
    name: 'SingleService',
    components: {
    Single,
    ServiceCategory
  },
    data () {
      return {
        searchValue: '',
        clusterIcon: [],
        catTitle: '',
        sortDirection: '',
        sortBy: 'name',
        markers: [],
        center: {
          lat: 51.093048,
          lng: 6.842120
        },
        mapStyle: {
          draggable: true,
          zoomControl: false,
          mapTypeControl: false,
          scaleControl: false,
          streetViewControl: false,
          rotateControl: false,
          fullscreenControl: false,
          animation: 2,
          disableDefaultUI: true,
           styles:[{featureType:"water",elementType:"geometry",stylers:[{color:"#e9e9e9"},{lightness:17}]},{featureType:"landscape",elementType:"geometry",stylers:[{color:"#f5f5f5"},{lightness:20}]},{featureType:"road.highway",elementType:"geometry.fill",stylers:[{color:"#ffffff"},{lightness:17}]},{featureType:"road.highway",elementType:"geometry.stroke",stylers:[{color:"#ffffff"},{lightness:29},{weight:0.2}]},{featureType:"road.arterial",elementType:"geometry",stylers:[{color:"#ffffff"},{lightness:18}]},{featureType:"road.local",elementType:"geometry",stylers:[{color:"#ffffff"},{lightness:16}]},{featureType:"poi",elementType:"geometry",stylers:[{color:"#f5f5f5"},{lightness:21}]},{featureType:"poi.park",elementType:"geometry",stylers:[{color:"#dedede"},{lightness:21}]},{elementType:"labels.text.stroke",stylers:[{visibility:"on"},{color:"#ffffff"},{lightness:16}]},{elementType:"labels.text.fill",stylers:[{saturation:36},{color:"#333333"},{lightness:40}]},{elementType:"labels.icon",stylers:[{visibility:"off"}]},{featureType:"transit",elementType:"geometry",stylers:[{color:"#f2f2f2"},{lightness:19}]},{featureType:"administrative",elementType:"geometry.fill",stylers:[{color:"#fefefe"},{lightness:20}]},{featureType:"administrative",elementType:"geometry.stroke",stylers:[{color:"#fefefe"},{lightness:17},{weight:1.2}]}]
        },
        pategory: '',
        name: '',
        range: '1000',
        fService: [],
        services: []
      }
    },
    mounted () {
      this.$nextTick( function () {
        var string = this.$route.params.title;
        const catTitle = string.split( "-" ).join( " " );
        this.catTitle = catTitle
      } )
    },

    computed: {
        filteredItems: function() {
    return this.services.filter(service => {
          return (service.categoriesValue.includes(this.$route.params.title))
        }).sort((p1,p2) => {
                    let modifier = 1;
                    if(this.sortDirection === 'desc') modifier = -1;
                    if(p1[this.sortBy] < p2[this.sortBy]) return -1 * modifier; if(p1[this.sortBy] > p2[this.sortBy]) return 1 * modifier;
                    return 0;
                });       
     
    },
            filteredRegion: function() {
    return this.services.filter(service => {
          return (service.region.toLowerCase().includes(this.$route.params.title.toLowerCase()))
        }).sort((p1,p2) => {
                    let modifier = 1;
                    if(this.sortDirection === 'desc') modifier = -1;
                    if(p1[this.sortBy] < p2[this.sortBy]) return -1 * modifier; if(p1[this.sortBy] > p2[this.sortBy]) return 1 * modifier;
                    return 0;
                });       
     
    },    

      singleItem: function () {
        return this.services.filter( service => {
          return service.slug.toLowerCase() === this.$route.params.title.toLowerCase();
          
        } )
      }

    },

    methods: {
      filterProductsByName: function () {
        return this.filteredItems.filter( ( service ) => {
          return service.title.toLowerCase().match( this.name );
        } );
      },
      hasHistory () {
        return window.history.length > 2
      }
    },

    created () {
console.log('singlealive')
dataPromise.then(data => {
  // console.log(data);
  this.services = data
});
    },

  }

</script>

<style lang="scss">
// @import '@/assets/app.scss';
</style>
